import request from '@/core/request'
import { ref, onMounted } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { useToast } from '@/ui-runtime/core/composable/use-toast'
import dayjs from 'dayjs'
import { useDialogs } from '@/ui-runtime/core/composable/use-dialogs'

export const defaultConfig = {
  key: 'ui-checkin1', // 每个ui组件必须有
  type: 'ui-checkin1', //
  images: {
    checkinDialogBg: 'checkin-dialog-bg',
    checkinEntry: 'checkin-icon-entry',
    checkinDays: ['day1', 'day2', 'day3', 'day4', 'day5', 'day6', 'day7'],
    checkinGot: 'checkin-btn-got',
    checkinGet: 'checkin-btn-get',
    checkinIconChecked: 'checkin-icon-checked',
  }, // 每个组件的配置都统一放到images中管理
  layout: {},
  config: {
    configApi: '/api/activities/general/checkin/detail',
    signinApi: '/api/activities/general/checkin',
    componentId: 1,
    checkinDialogName: 'checkin',
    tipText: '您已领第{progress}天奖励，继续加油哦～',
  }, //每个ui组件的一些配置字段相关的东西
}

export const useCheckin = (uiMeta: any) => {
  const { config } = uiMeta
  const route = useRoute()
  const { $dialogs } = useDialogs()
  const activity_code = route.meta?.activity_code

  const progress = ref(0)
  const isSignToday = ref(false)
  const { $toast } = useToast()
  const { data: configData, refetch: refetchConfigData } = useQuery({
    queryKey: ['configData'],
    queryFn: async () => {
      const res = await request.get(config.configApi, {
        activity_code,
        component_id: config.componentId,
      })
      if (res.status !== 0) {
        $toast.show((res as any).msg || '获取签到配置失败')
        return
      }

      progress.value = res.data.finish_checkin_days
      isSignToday.value = res.data.current_status === 1
      return res
    },
  })

  const open = () => {
    $dialogs[config.checkinDialogName].open({
      data: {
        configData: configData.value,
      },
    })
  }

  const closeCheckin = () => {
    $dialogs[config.checkinDialogName].close()
  }

  // 处理自动弹出逻辑，每天自动弹出一次，以日期和路由作为key标识
  onMounted(() => {
    const key = `${activity_code}-${config.componentId}-${dayjs().format('YYYY-MM-DD')}`
    const stored = localStorage.getItem(key)
    if (stored === 'true') {
      return
    }
    open()
    localStorage.setItem(key, 'true')
  })

  const signin = async () => {
    const res = await request.post(config.signinApi, {
      activity_code,
      component_id: config.componentId,
    })
    if (res.status !== 0) {
      $toast.show((res as any).msg || '签到失败')
      return
    }

    refetchConfigData()
  }

  return {
    signin,
    progress,
    isSignToday,
    open,
    closeCheckin,
  }
}
